import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito diagnóstico médico de SIBO para empezar?',
    a: 'No. El Protocolo está diseñado para mujeres con síntomas activos. Si ya tenés diagnóstico, mejor. Si no, el Tomo 1 te da las herramientas para identificar tu perfil de síntomas.'
  }, {
    q: '¿Los ingredientes son difíciles de conseguir?',
    a: 'No. Todo el Protocolo fue diseñado específicamente para la verdulería del barrio, el super de la esquina y la herboristería más cercana. Nada importado, nada imposible.'
  }, {
    q: '¿Puedo acceder desde el celular?',
    a: 'Sí. Acceso inmediato desde cualquier dispositivo. Los PDFs están optimizados para leer en pantalla y también para imprimir.'
  }, {
    q: '¿Recibo algo físico?',
    a: 'No. El Protocolo Rescate SIBO es un producto 100% digital. Una vez realizada la compra, recibís acceso inmediato al contenido por correo electrónico y podés verlo en tu celular o computadora.'
  }, {
    q: '¿La garantía es real?',
    a: '100% real. Un mail a soportebiomalivido@gmail.com dentro de los 7 días y te devolvemos todo. Sin preguntas.'
  }, {
    q: '¿Por qué $23.990?',
    a: 'Porque este protocolo reemplaza años de turnos médicos, análisis, suplementos caros y dietas que no funcionaron. $23.990 es una fracción de lo que ya gastaste buscando la respuesta que está acá.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-forest-50 py-20 px-4" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-forest-900 mb-12" data-id="element-35">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-36">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-forest-800/10 overflow-hidden transition-all duration-200 shadow-sm" data-id="element-37">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-38">
                <span className="font-bold text-lg text-forest-900 pr-4" data-id="element-39">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="w-5 h-5 text-gold-500 flex-shrink-0" data-id="element-40" /> : <ChevronDown className="w-5 h-5 text-forest-800/40 flex-shrink-0" data-id="element-41" />}
              </button>

              {openIdx === idx && <div className="px-6 pb-5 text-forest-800" data-id="element-42">
                  <p data-id="element-43">{faq.a}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}